import { GetIncidentCategories } from "./ApiCalls/categories/getIncidentCategories";
import { PatchIncidentCategory } from "./ApiCalls/categories/patchIncidentCategory";
import { PostIncidentCategory } from "./ApiCalls/categories/postIncidentCategory";
import { GetIncidentCategoriesNotDefault } from "./ApiCalls/categories/getIncidentCategoriesNotDefault";
import { DisableIncidentCategory } from "./ApiCalls/categories/disableIncidentCategory";
import { DisableIncidentCategoryGroup } from "./ApiCalls/categories/disableCategoryGroup";


export async function GetIncidentCategoriesService(company) {
  try {
    const categories = await GetIncidentCategories(company);

    // Filtrar primero por categorías habilitadas (enabled true)
    const filteredCategories = categories.filter(category => category.enabled);

    // Mapear las categorías filtradas
    const CategoriesData = filteredCategories.map((category) => ({
      label: category.name,
      value: category.incidentCategory1,
      categoryGroup: category.categoryGroup,
    }));

    return CategoriesData;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function GetIncidentCategoriesNotDefaultService(company) {
  const categories = await GetIncidentCategoriesNotDefault(company);
  const CategoriesData = categories.map((category) => ({
    name: category.name,
    incidentCategory: category.incidentCategory1,
    company: category.company,
    categoryGroup: category.categoryGroup,
    language: category.language,
    enabled: category.enabled,
    createdAt: category.createdAt
  }));

  return CategoriesData;
}

export async function PostIncidentCategoryService(incidentCategory) {
  try {
    const categories = await PostIncidentCategory(incidentCategory);

    return categories;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function PatchIncidentCategoryService(
  incidentCategoryId,
  incidentCategory
) {
  try {
    const categories = await PatchIncidentCategory(
      incidentCategoryId,
      incidentCategory
    );

    return categories;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function DisableIncidentCategoryService(
  incidentCategory,
  incidentCategoryId
) {
  try {
    const categories = await DisableIncidentCategory(
      incidentCategory,
      incidentCategoryId
    );

    return categories;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function DisableCategoryGroupService(
  categoryGroup
) {
  try {
    const categories = await DisableIncidentCategoryGroup(
      categoryGroup
    );

    return categories;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}